import _ from 'lodash';
import { recordDisplay, numberWithComma } from 'src/utils/Utils';

// 簡易設定の年税額を取得する
// 基準月~5月までの合計値を年税額とする
// 例: 基準月=3月 基準月の住民税額: 10 基準以降の住民税額: 20
//     10(3) + 20(4) + 20(5) => 50
// 例: 基準月=6月 基準月の住民税額: 10 基準以降の住民税額: 20
//     10(6) + 20 * 11(7月~5月) => 230
export const annualInhabitantTaxOfSimple = (landmarkMonth, taxAmountLandmark, taxAmountAfterLandmark) => {
  // 17(12月 + 5月) 循環の基準を5月にしている
  const tax = +taxAmountLandmark + +taxAmountAfterLandmark * ((17 - +landmarkMonth) % 12);
  return recordDisplay(Number.isFinite(tax) && `${numberWithComma(tax)}円`);
};

// 月別設定の年税額を取得する
export const annualInhabitantTaxOfMonth = taxAmounts => {
  const sum = _.sumBy(taxAmounts, ta => Number(ta.amount));
  return recordDisplay(Number.isFinite(sum) && `${numberWithComma(sum)}円`);
};

// 各月の住民税額から対象月の住民税額を取得する
export const getTaxAmountLandmark = (taxAmounts, landmarkMonth) => {
  const find = _.find(taxAmounts, ({ month }) => month === landmarkMonth);
  return find ? find.amount : 0;
};

// 各月の住民税額から対象月以降の住民税額を取得する
export const getTaxAmountAfterLandmark = (taxAmounts, landmarkMonth) => {
  const maxMonth = taxAmounts.length;
  const month = landmarkMonth % maxMonth + 1;
  return getTaxAmountLandmark(taxAmounts, month);
};
